import { httpClient } from '@/httpClient';

const getCalculatedPriceRu = (params) => httpClient.get('/orders/calculate_price', { params });
const getCalculatedPriceEn = (params) => httpClient.get('/forms/orders/calculate_price', { params });

const createOrder = async (fd) => httpClient.post('/forms/orders', fd);

const createOrderWithoutPlans = async (email) => httpClient.post('/forms/orders_without_plans', { email });

const askQuestion = async (fd) => httpClient.post('/forms/question', fd);
const askQuestionEn = async (fd) => httpClient.post('/forms/contact', fd);

const createOrderModal = async (fd) => httpClient.post('/orders', fd);
const getConfirmationToken = async (fd) => httpClient.post('/orders', fd);

const demoOrder = async (fd) => httpClient.post('/forms/demo', fd);

const getAuthUserData = async () => httpClient.get('/account');

const refreshToken = async () => httpClient.post('/auth/refresh');

const sendContact = async (fd) => httpClient.post('/forms/contact', fd);

export const api = {
  createOrder,
  createOrderWithoutPlans,
  getCalculatedPriceRu,
  getCalculatedPriceEn,
  askQuestion,
  createOrderModal,
  getConfirmationToken,
  demoOrder,
  getAuthUserData,
  refreshToken,
  sendContact,
  askQuestionEn,
};
